import { Api } from "../helpers";

export const closureQuestionService = {
  getList
};

// get the list of all accept protools
// {state: 'all}
function getList(options) {
  return Api()
    .get("/closure-question/all", { params: options })
    .then(response => {
      return response.data.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}